/**
 * @generated SignedSource<<12834ac364ed28e0aa13e3fdfc0c6097>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
import { FragmentRefs } from "relay-runtime";
export type useDepartmentGolfFacilitiesGroupSize_department$data = {
  readonly facilities: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly minMaxGroupSize: {
          readonly max: number | null | undefined;
          readonly min: number | null | undefined;
        } | null | undefined;
        readonly type: FacilityType;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useDepartmentGolfFacilitiesGroupSize_department";
};
export type useDepartmentGolfFacilitiesGroupSize_department$key = {
  readonly " $data"?: useDepartmentGolfFacilitiesGroupSize_department$data;
  readonly " $fragmentSpreads": FragmentRefs<"useDepartmentGolfFacilitiesGroupSize_department">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useDepartmentGolfFacilitiesGroupSize_department",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FacilityConnection",
      "kind": "LinkedField",
      "name": "facilities",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FacilityEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "bookingType",
                      "value": "STANDARD"
                    }
                  ],
                  "concreteType": "GroupSize",
                  "kind": "LinkedField",
                  "name": "minMaxGroupSize",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "min",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "max",
                      "storageKey": null
                    }
                  ],
                  "storageKey": "minMaxGroupSize(bookingType:\"STANDARD\")"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Department",
  "abstractKey": null
};

(node as any).hash = "bcf2e1a0552b0dae390cbc9eac9ad285";

export default node;
